export const chapters = [
  {
    _id: "66cffff724d951004a7f2455",
    title: "Biology Second Year Secondary",
  },
  {
    _id: "66d0008924d951004a7f2457",
    title: "Physics First Year Secondary",
  },
  {
    _id: "66d0016024d951004a7f2459",
    title: "Geography Third Year Preparatory",
  },
];

export const pages = [
  {
    _id: "66684e63e4163f0056e5fc29",
    url: "https://scube-applications-media54cbabfc-u3d19945rbtv.s3.eu-west-1.amazonaws.com/eBooks/azharengineering2020/ut500/Alahaiaa-llsaf-alaol-althanoi/Albab-althalth:-twarth-alsafat/page_2.png",
    blocks: [],
  },
  {
    _id: "66684e63e4163f0056e5fc29",
    url: "https://scube-applications-media54cbabfc-u3d19945rbtv.s3.eu-west-1.amazonaws.com/eBooks/azharengineering2020/ut500/Alahaiaa-llsaf-alaol-althanoi/Albab-althalth:-twarth-alsafat/page_2.png",
    blocks: [
      {
        blockId: "667a9eabd67020431ef4a68f",
        coordinates: {
          x: 12.5,
          y: 12.5,
          width: 10,
          height: 20,
        },
        contentType: "Text MCQ",
        contentValue: "6662f6e41f62310044bd897d",
        isDeep: true,
      },
      {
        // No isDeep key — mirrors blocks saved before the flag existed.
        blockId: "667a9eacd67020431ef4a699",
        coordinates: {
          x: 12.5,
          y: 12.5,
          width: 10,
          height: 20,
        },
        contentType: "Picture",
        contentValue:
          "https://scube-applications-media54cbabfc-u3d19945rbtv.s3.eu-west-1.amazonaws.com/eBooks/azharengineering2020/ut500/Alahaiaa-llsaf-alaol-althanoi/Albab-althalth:-twarth-alsafat/page_2.png",
      },
    ],
  },
  {
    _id: "66684e63e4163f0056e5fc29",
    url: "https://scube-applications-media54cbabfc-u3d19945rbtv.s3.eu-west-1.amazonaws.com/eBooks/azharengineering2020/ut500/Alahaiaa-llsaf-alaol-althanoi/Albab-althalth:-twarth-alsafat/page_2.png",
    blocks: [
      {
        blockId: "667a9eacd67020431ef4a699",
        coordinates: {
          x: 12.5,
          y: 12.5,
          width: 10,
          height: 20,
        },
        contentType: "Paragraph",
        contentValue:
          "In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. Lorem ipsum may be used as a placeholder before the final copy is available.",
      },
    ],
  },
];
